import { ChangeEvent, useCallback, useState } from 'react';

export const useChangePasswordValue = () => {
  const [password, setPassword] = useState('');

  const changePassword = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setPassword(e.target.value);
    },
    [setPassword]
  );

  return { password, changePassword };
};
